export default [
    //信息漏镀  0810
    {
        path: '/battleNet',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/msgFunnel/battleNet/battleNet.vue')
    },
    {
        path: '/grabOrdersCustom',
        component: () => import( '@/views/msgFunnel/grabOrdersCustom/grabOrdersCustom.vue'),
        meta: {
            title: '网络月度抢单',
            isTabsPage: true,
            keepAlive:true
        }
    },
    {
        path: '/forecastedOrder',
        component: () => import( '@/views/msgFunnel/forecastedOrder/forecastedOrder.vue'),
        meta: {
            title: '月度订单预测',
            isTabsPage: true,
            keepAlive:true
        }
    },
    {
        path: '/clauseOrdersCustom',
        component: () => import( '@/views/msgFunnel/clauseOrdersCustom/clauseOrdersCustom.vue'),
        meta: {
            title: '月度抢单-非签约',
            isTabsPage: true,
            keepAlive:true
        }
    },
    {
        path: '/quarterlyGrabOrder',
        component: () => import( '@/views/msgFunnel/QuarterlyGrabOrder/QuarterlyGrabOrder.vue'),
        meta: {
            title: '季度抢单-客户',
            isTabsPage: true,
            keepAlive:true
        }
    },
    {
        path: '/grabOrder',
        component: () => import( '@/views/msgFunnel/QuarterlyGrabOrder/grabOrder.vue'),
        meta: {
            title: '季度抢单-非签约',
            isTabsPage: true,
            keepAlive:true
        }
    },
    {
        path: '/battleNetUser',
        component: () => import( '@/views/msgFunnel/battleNetUser/battleNetUser.vue'),
        meta: {
            title: '目标对阵用户',
            isTabsPage: true,
            keepAlive:true
        }
    },
    {
        path: '/targetAgainstUserTabs',
        component: () => import( '@/views/msgFunnel/battleNetUser/targetAgainstUserTabs.vue'),
        meta: {
            title: '目标对阵用户',
            isTabsPage: true,
            keepAlive:true
        }
    },
    {
        path: '/battleNetUserDel',
        component: () => import( '@/views/msgFunnel/battleNetUser/battleNetUserDel.vue'),
        meta: {
            title: '目标对阵用户删除审批列表',
            isTabsPage: false,
            keepAlive:false
        }
    },
    {
        path: '/battleNetUserAdd',
        component: () => import( '@/views/msgFunnel/battleNetUser/battleNetUserAdd.vue'),
        meta: {
            title: '目标对阵用户新增审批列表',
            isTabsPage: false,
            keepAlive:false
        }
    },
    {
        path: '/battleNetUserUpdate',
        component: () => import( '@/views/msgFunnel/battleNetUser/battleNetUserUpdate.vue'),
        meta: {
            title: '目标对阵用户修改审批列表',
            isTabsPage: false,
            keepAlive:false
        }
    },
    {
        path: '/topUserManagement',
        component: () => import( '@/views/msgFunnel/topUserManagement/topUserManagement.vue'),
        meta: {
            title: 'TOP用户管理',
            isTabsPage: true,
            keepAlive:true
        }
    },
    {
        path: '/topUserManagementUpdate',
        component: () => import( '@/views/msgFunnel/topUserManagement/topUserManagementUpdate.vue'),
        meta: {
            title: 'TOP用户管理修改审批流',
            isTabsPage: false,
            keepAlive:false
        }
    },
    {
        path: '/topUserManagementImport',
        component: () => import( '@/views/msgFunnel/topUserManagement/topUserManagementImport.vue'),
        meta: {
            title: 'TOP用户管理新增或者导入审批流',
            isTabsPage: false,
            keepAlive:false
        }
    },
    {
        path: '/topUserManagementDel',
        component: () => import( '@/views/msgFunnel/topUserManagement/topUserManagementDel.vue'),
        meta: {
            title: 'TOP用户管理删除审批流',
            isTabsPage: false,
            keepAlive:false
        }
    },
    {
        path: '/orderAppeal',
        component: () => import( '@/views/loud/appeal/orderAppeal.vue'),
        meta: {
            title: '窜货申诉',
            isTabsPage: false,
            keepAlive:false
        }
    },
    {
        path: '/orderAppealAdd',
        component: () => import( '@/views/loud/appeal/orderAppealAdd.vue'),
        meta: {
            title: '新建申诉',
            isTabsPage: false,
            keepAlive:false
        }
    },
    {
        path: '/orderAppealDetail',
        component: () => import( '@/views/loud/appeal/orderAppealDetail.vue'),
        meta: {
            title: '查看申诉',
            isTabsPage: true,
            keepAlive:true
        }
    },
    {
        path: '/topUserReportForms',
        component: () => import( '@/views/msgFunnel/topUserReportForms/topUserReportForms.vue'),
        meta: {
            title: 'TOP用户报表',
            isTabsPage: true,
            keepAlive:true
        }
    },
    {
        path: '/topTendersMessage',
        component: () => import( '@/views/msgFunnel/topUserReportForms/topTendersMessage.vue'),
        meta: {
            title: 'TOP招标信息',
            isTabsPage: true,
            keepAlive:true
        }
    },
    {
        path: '/infoIndex',
        component: ()=>import('@/views/msgFunnel/funnelInfo/infoIndex.vue'),
    },
    {
        path: '/infoIndexLoudShnepi',
        component: ()=>import('@/views/msgFunnel/funnelInfo/infoIndexLoudShnepi.vue'),
    }
]
